import * as React from 'react';
const SvgArrowCounterClockwise = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M11.98 3C9.143 3 6.636 4.33 4.988 6.38V4.8c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22.55.55 0 0 0-.25-.05H3.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22C3 4.38 3 4.52 3 4.8v2.4c0 1 0 2.04.11 2.25.05.1.12.19.2.27.07.07.15.13.24.17.21.11 1.248.11 2.247.11h2.397c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.02-.04.03-.07.04-.12.02-.09.02-.22.02-.41v-.4c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22C8.624 8 8.484 8 8.204 8H6.256c.06-.07.12-.15.21-.26A6.99 6.99 0 0 1 12.01 5a6.99 6.99 0 0 1 6.992 7c0 3.87-3.126 7-6.992 7a6.95 6.95 0 0 1-4.345-1.52c-.24-.19-.37-.29-.47-.32a.5.5 0 0 0-.29.02c-.1.04-.2.14-.399.33l-.28.28c-.2.2-.29.29-.33.42-.03.1-.02.23.01.33.05.12.14.2.34.36A8.92 8.92 0 0 0 12.01 21c4.964 0 8.99-4.03 8.99-9s-4.055-9-9.02-9"
    />
  </svg>
);
export default SvgArrowCounterClockwise;
